import { render, staticRenderFns } from "./FormSetting.vue?vue&type=template&id=33492622&scoped=true"
import script from "./FormSetting.vue?vue&type=script&lang=js"
export * from "./FormSetting.vue?vue&type=script&lang=js"
import style0 from "./FormSetting.vue?vue&type=style&index=0&id=33492622&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33492622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33492622')) {
      api.createRecord('33492622', component.options)
    } else {
      api.reload('33492622', component.options)
    }
    module.hot.accept("./FormSetting.vue?vue&type=template&id=33492622&scoped=true", function () {
      api.rerender('33492622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/components/FormSetting.vue"
export default component.exports